import { formatDistance, format } from "date-fns";
export const GetActivity = async (data: any) => {
  const dataArray = await setActivity(data || []);
  return activity(dataArray);
};
export const GetRecentActivity = async (data: any) => {
  const dataArray = await setActivity(data || []);
  return recentActivity(dataArray);
};

const setActivity = async (data: any) => {
  let newArrayData: any = [];

  await data.forEach(async (element: any) => {
    const day = await getDay(element.created_at);
    const newElement = { ...element, day };
    newArrayData.push(newElement);
  });
  const dataArray = await newArrayData.reduce((data: any, { day, ...item }: any) => {
    if (!data[day]) data[day] = [];
    data[day].push(item);
    return data;
  }, {});
  return dataArray;
};

const recentActivity = (data: any) => {
  const newData = [];
  for (const day in data) {
    if (day === "Today" || day === "Yesterday") {
      const id = data[day][0]["id"] + `${day}`;
      const newEntry = {
        id: id,
        groupName: day,
        elements: data[day],
      };

      newData.push(newEntry);
    }
  }

  return newData;
};

const activity = (data: any) => {
  const newData = [];
  for (const day in data) {
    const id = data[day][0]["id"] + `${day}`;
    const newEntry = {
      id: id,
      groupName: day,
      elements: data[day],
    };
    newData.push(newEntry);
  }

  return newData;
};

export const formatFileSize = (bytes: number): string => {
  const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb"];
  if (bytes === 0) return "0 Bytes";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);
  return `${size.toFixed(1)} ${sizes[i]}`;
};
const getDay = async (dateString: any) => {
  const key = {
    Minute: "minute",
    Today: "hour",
    Yesterday: "day",
    Others: "days",
  };
  const day = formatDistance(new Date(dateString), new Date());
  if (day.includes(key.Minute) || day.includes(key.Today)) {
    return "Today";
  } else if (day.includes(key.Yesterday) && !day.includes(key.Others)) {
    return "Yesterday";
  } else {
    const result = format(new Date(dateString), "dd/MMMM/yyyy");
    return result;
  }
};

export const openFileUrlInNewWindow = (url: string) => {
  window.open(url, "blank");
};
export const capitalizeFirst = (str: string) => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
};

export const convertToTitleCase = (title: any) => {
  if (typeof title === "string") {
    let words = title?.split(" ");
    for (let i = 0; i < words?.length; i++) {
      let word = words[i];
      words[i] = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return words.join(" ");
  } else {
    return title;
  }
};

export const blockInvalidChar = (e: any) =>
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

export const hexToRgb = (hex: string, asArray = false) => {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, "");

  // Parse the hex color depending on the length (3 or 6)
  let r, g, b;
  if (hex.length === 3) {
    // If the hex code is in shorthand form, expand it to the full form
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    // If the hex code is in full form, parse normally
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    throw new Error("Invalid hex color code");
  }

  // Return as array or string based on the asArray parameter
  if (asArray) {
    return [r, g, b];
  } else {
    return `rgb(${r}, ${g}, ${b})`;
  }
};

export const wait = (n: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, n * 1000);
  });

export function getUniqueId() {
  const min = Math.pow(10, 10); // Minimum 11-digit number (10000000000)
  const max = Math.pow(10, 11) - 1; // Maximum 11-digit number (99999999999)

  return `a${Math.floor(Math.random() * (max - min + 1)) + min}`;
}

export const convertImageToBase64 = (
  imageUrl: string,
  width: number,
  height: number
): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      reject("Failed to get canvas context.");
      return;
    }

    const img = new Image();
    img.crossOrigin = "Anonymous"; // Important for loading images from different origins
    img.src = imageUrl; // Use the defined image URL

    img.onload = () => {
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height); // Draw image to canvas at current dimensions

      try {
        const dataURL = canvas.toDataURL("image/png"); // Get Base64 string
        resolve(dataURL);
      } catch (error) {
        console.error("Error converting to Base64:", error);
        reject(
          "Error converting image to Base64. Check console for details. (Cross-origin issues might occur)"
        );
      }
    };

    img.onerror = () => {
      console.error("Image loading failed for Base64 conversion:", imageUrl);
      reject(
        "Failed to load image for Base64 conversion. Please ensure the image URL is accessible and supports cross-origin requests."
      );
    };
  });
};

export function calculateScaleRate(originalNumber: number, newNumber: number): number {
  // Handle the edge case where originalNumber is zero
  if (originalNumber === 0) {
    // If both are zero, there's no change, so the scale rate is 1.
    if (newNumber === 0) {
      return 1;
    }
    // If original is zero and new is non-zero, it's not a meaningful 0-1 scale from the original.
    // We return 0 to indicate it's not "scaled up" relative to the original zero.
    return 0;
  }

  // Calculate the raw ratio
  const rawRatio = newNumber / originalNumber;

  // Clamp the ratio between 0 and 1
  return Math.min(1, Math.max(0, rawRatio));
}
